const en = {
  common: {
    senseInsights: 'Next Sense Insights',
    cancel: 'Cancel',
    ok: 'OK',
    back: 'Back',
    darkMode: 'Switch to dark mode',
    lightMode: 'Switch to light mode',
    comingSoon: 'Coming soon',
    welcome: 'Welcome',
    loading: 'Loading...',
    mobileInfo: 'This application supports only desktop version',
    desktopInfo: 'This application supports only mobile version',
    somethingWentWrong: 'Something went wrong, please try again later',
    tenant: 'Tenant',
    building: 'Building',
    noChartAvailable: 'There is no chart available.',
    minimum: 'Minimum',
    maximum: 'Maximum',
    average: 'Average',
    error429: 'Cannot retrieve your information, try again later',
    user: 'User',
    contact: 'Contact Next Sense',
    contactUs: 'Contact Us',
    organisation: 'Organisation',
    project: 'Building',
    floor: 'Floor',
    room: 'Room',
    sensor: 'Sensor',
    sendEmail: 'Send E-mail',
    send: 'Send',
    to: 'to',
    resend: 'Resend',
    continue: 'Continue',
    above: 'Above',
    below: 'Below',
    showDetails: 'Show Details',
    hideDetails: 'Hide Details',
    save: 'Save',
    auto: 'Auto',
    success: 'Success',
  },
  navigation: {
    insights: 'Insights',
    explorer: 'Explore',
    reports: 'Reports',
    service: 'Service',
    configure: 'Configure',
    settings: 'Settings',
    profile: 'Profile',
    perfAudit: 'Perf. Audit',
    control: 'Controls',
  },
  insights: {
    pageTitle: 'Insights',
  },
  explorer: {
    pageTitle: 'Explore',
  },
  reports: {
    pageTitle: 'Reports',
  },
  service: {
    pageTitle: 'Service',
    emailSubject: 'Support request from {{selectedProject}}',
    contactUsText:
      'If you have any questions or feedback, please reach out to us',
  },
  configure: {
    pageTitle: 'Configure',
    actuators: {
      moveAllBlindsUp: 'Move all blinds up',
      moveBlindsUp: 'Move blinds up',
      moveAllBlindsDown: 'Move all blinds down',
      moveBlindsDown: 'Move blinds down',
      moveToAutoMode: 'Move back to auto mode',
      setWorkingHours: 'Set Working Hours',
    },
  },
  settings: {
    pageTitle: 'Settings',
  },
  profile: {
    pageTitle: 'Profile',
  },
  notFound: {
    pageTitle: 'Not Found',
    didYouMean: 'Did you mean',
    notFound: 'Page not found',
  },
  temperature: {
    tooltipDay: 'Date: {{day}}',
    tooltipIndoor: 'Indoor temperature: {{indoor}}',
    tooltipOutdoor: 'Outdoor temperature: {{outdoor}}',
    comfortThresholdInfo: 'within comfortable range',
    comfortThresholdAdditionalInfo: 'between {{min}}-{{max}} °C',
    comfortThresholdErrorMessage:
      'No percentage available of rooms within temperature comfortable range',
    errorMessage: 'No graph available for temperature',
  },
  humidity: {
    comfortThresholdInfo: 'within comfortable range',
    comfortThresholdAdditionalInfo: 'between {{min}}-{{max}} %',
    comfortThresholdErrorMessage:
      'No percentage available of rooms within humidity comfortable range',
    errorMessage: 'No graph available for humidity',
  },
  lux: {
    comfortThresholdInfo: 'within comfortable range',
    comfortThresholdAdditionalInfo: 'between {{min}}-{{max}} lux',
  },
  unobstructedView: {
    info: 'Unobstructed view outside',
    errorMessage:
      'No percentage available for the blinds with unobstructed view',
  },
  blindAutoMode: {
    info: 'Blinds in auto mode',
    errorMessage: 'No percentage available for the blinds in Auto mode',
  },
  occupancy: {
    comfortThresholdInfo: 'average occupancy',
    comfortThresholdAdditionalInfo: 'for the last 8 hours',
    comfortThresholdErrorMessage:
      'No percentage available of the occupied rooms',
    errorMessage: 'No graph available for rooms occupied',
  },
  energyBalance: {
    errorMessage: 'No graph available for energy performance',
  },
  CO2: {
    comfortThresholdInfo: 'within comfortable range',
    comfortThresholdAdditionalInfo: 'below {{max}} ppm',
    comfortThresholdErrorMessage:
      'No percentage available of rooms within CO2 comfortable range',
    errorMessage: 'No graph available for CO2 Level',
  },
  weatherPrediction: {
    currentErrorMessage: 'No current weather information available',
    forecastErrorMessage: 'No weather forecast available',
  },
  performanceTarget: {
    comfortThresholdInfo: 'Performance Target',
    comfortThresholdAdditionalInfo: 'of {{max}} kWh/m2/year',
    errorMessage: 'No percentage available of the building Performance Target',
  },
  parisProof: {
    comfortThresholdInfo: 'Reduction required to achieve Paris Proof',
    comfortThresholdAdditionalInfo: 'target of 50 kWh/m2/year',
    errorMessage:
      'No percentage available of the building Paris Proof achievement',
    comfortThresholdStatus: 'Better than Paris Proof',
  },
  buildingPerformance: {
    errorMessage: 'No graph available for Building Performance',
  },
  errors: {
    noLocalStorageKey: 'The key does not exist',
    noCameraProps: 'There is no camera properties',
    noDOMElement: 'There is no DOM element',
    noRequest: 'Request not found',
    unAuthorized: 'Unauthorized',
    badRequest: 'Bad request',
    forbidden: 'Incorrect Details',
    wrongResponseException: 'Something went wrong, please try again later',
    dataMissing: 'Data missing',
    dataLoading: 'Data Loading',
    chart: 'No chart available for',
  },
  auth: {
    login: 'Login',
    logout: 'logout',
    forgotPass: 'forgot password?',
    password: 'Password',
    username: 'user name',
    signIn: 'Sign In',
    getInsights: 'and get insights into your office climate',
    rememberMe: 'remember me',
    copy: 'Copyright © Next Sense {{year}}',
    passwordLength: 'Password should have at least 6 characters',
    emailPlaceholder: 'E-mail',
    otpNotificationTitle: 'Please enter your login code.',
    otpNotification: 'If you did not receive a code in your mailbox, please',
    invalidEmail: 'please fill in a correct email address',
    forgotPasswordTitle: 'Forgot Password',
    forgotPasswordText: 'No worries, we will send you reset instructions',
    createPassword: 'Create Password',
    resetPasswordTitle: 'Reset Password',
    logoutMessage: 'This action will end the session',
    loginSubText:
      'Log in to access real-time readings of temperature, air quality, light, and humidity sensors around your building.',
    backToLogin: 'Back to login',
    checkYourEmail: 'Check your E-mail',
    checkYourEmailText: 'We’ve sent a password with reset link to',
    emailRecieveError: 'Didn’t receive the e-mail?',
    setNewPasswordTitle: 'Set new password',
    setNewPasswordText:
      'Your new password needs to different than previously used.',
    confirmPasswordPlaceholder: 'Confirm Password',
    confirmNewPasswordTitle: 'Password Reset',
    confirmNewPasswordText:
      'Password reset has been successful. Click below to login.',
  },
  makeViewer: {
    viewFit: 'View Fit',
    viewFitAll: 'View Fit All',
    showInTree: 'Show in Tree',
    hide: 'Hide',
    hideOthers: 'Hide Others',
    hideAll: 'Hide All',
    show: 'Show',
    showAll: 'Show All',
    showOthers: 'Show Others',
    xRay: 'X-Ray',
    undoXRay: 'Undo X-Ray',
    xRayOthers: 'X-Ray Others',
    resetXRay: 'Reset X-Ray',
    select: 'Select',
    undoSelect: 'Undo Select',
    clearSelection: 'Clear Selection',
    deSelect: 'Deselect',
    toggleNav: 'Toggle navigation cube',
    toggleStoreyMap: 'Toggle Storey Map',
    toggleTree: 'Toggle Tree',
    fullModelView: 'Full Model View',
    floor: 'Floor {{nth}}',
    selectStorey: 'Select storey',
    resetCamera: 'Reset camera',
    noModelError: 'Something went wrong with the model',
  },
  widgets: {
    'visual-comfort': 'Visual Comfort',
    'air-quality': 'Air Quality',
    'space-utilization': 'Space Utilization',
    'thermal-comfort': 'Thermal Comfort',
    'acoustic-comfort': 'Acoustic Comfort',
    'energy-performance': 'Energy Performance',
    'energy-balance': 'Energy Balance in kWh',
    glare: 'Glare',
    'sound-pressure-level': 'Sound Pressure Level',
    'relative-humidity': 'Relative Humidity',
    'carbon-monoxide': 'Carbon Monoxide',
    'co2-level': 'CO2 Level',
    'predicted-mean-vote': 'Predicted Mean Vote',
    'desk-occupancy': 'Desk Occupancy',
    'voc-level': 'VOC Level',
    'daylight-autonomy': 'Daylight Autonomy',
    mobility: 'Mobility',
    'indoor-temperature': 'Indoor Temperature',
    'blind-performance': 'Blind Performance',
    'actual-mean-vote': 'Actual Mean Vote',
    'particulate-matter': 'Particulate Matter',
    'meeting-room-occupancy': 'Meeting Room Occupancy',
    'light-levels': 'Light Levels',
    'air-quality-index': 'Air Quality Index',
    'outdoor-activities': 'Outdoor activities',
    'smart-window-activity': 'SmartWindow activity versus cloud coverage',
    'air-quality-desc':
      'We monitor the air quality around your building. You could use this information when planning your activities for today or to keep track of it in general.',
    'outdoor-activity-desc':
      'Based on today’s weather prediction we suggest what kind of activities would be best for these circumstances. Make the most of today!',
    'smart-windowactivity-desc':
      'See how clouds impact the energy generation of your SmartSkin in the graph below.',
    infoButtonText:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam, purus sit amet luctus venenatis, lectus magna fringilla urna, porttitor rhoncus dolor purus non',
    'facade-illuminance': 'Facade Illuminance',
    'working-hours': 'Working Hours',
    'manual-override-all-blinds': 'Manual Override All Blinds',
    'manual-override-floor-blinds': 'Manual Override Blinds',
    'room-occupancy': 'Room Occupancy',
    'building-performance': 'Building Performance',
    'performance-target': 'Performance Target',
    'paris-proof': 'Paris Proof',
    'unobstructed-view': 'Unobstructed View',
    'blind-auto-mode': 'Blinds in auto mode',
    'comfort-threshold': 'Comfort Threshold',
    'facade-status': 'Facade Illuminance',
    'weather-predictions': 'Weather Predictions',
    'wind-alarm': 'Wind Alarm',
  },
  calendar: {
    now: 'Now (Past Hour)',
    today: 'Today',
    week: 'Past Week',
    month: 'Past Month',
    year: 'Past Year',
    cancel: 'Cancel',
    setDate: 'Set Date',
  },
  sideBar: {
    smartWindowsTitle: 'Transforming your building with',
    smartWindowsTitleHighlight: 'SmartWindows',
    smartWindowsDesc:
      'We are on a mission to reduce energy consumption in buildings and you’re helping our journey! Your ‘SmartWindows’ have unique functionality: they use the sun to generate green electricity, collect and store climate data with sensors and allow you to charge your electronic devices directly from the usb output with the energy generated by your window.',
    powerBoxTitle: 'Charge your device with sunpower from',
    powerBoxTitleHighlight: 'PowerBox',
    powerBoxDesc:
      'The PowerBox enables direct access to the energy generated by solar cells inside SmartWindows. Charging is possible for small electronic devices including smartphones and tablets (no laptops!), by connecting the supplied USB-c cable (<1m) to the PowerBox (only use the supplied USB-c cable for charging). A metal plate can then be used to hang the device magnetically onto the PowerBox.',
    footerText: 'Thanks for being an',
    footerSpan: 'Innovator',
  },
  projectHeader: {
    morning: 'Good Morning! We wish you a good day!',
    afternoon: 'Good Afternoon! We hope you are having a great day!',
    evening: 'Good Evening! See how your {{projectName}} performed today.',
    night: 'Good Night! Tomorrow there will be a new day of power generation.',
  },
  admin: {
    pageTitle: 'Sense Admin',
  },
  monitoring: {
    statusUp: 'Up',
    statusDown: 'Down',
    pageTitle: 'Monitoring',
  },
  commission: {
    pageTitle: 'Commission',
    controlCommission: 'Commission Control',
    scanQRLabel: 'Scan QR',
    successfulCommission: 'Successfully commissioned',
  },
  selectors: {
    noOrganisations: 'There are no organisations',
    noProjects: 'There are no projects',
    noFloors: 'There are no floors',
    noRooms: 'There are no rooms',
    noSensors: 'There are no sensors',
    floorLabel: 'Select Floor',
    roomLabel: 'Select Room',
    sensorLabel: 'Select Equipment',
    backToFloor: 'Back to floors',
    metrics: 'Select Metrics',
    hours: 'Select Hours',
    days: 'Select Days',
    scope: 'Select Scope',
    allRooms: 'All Rooms',
    allFloors: 'All Floors',
  },
  alerts: {
    success: 'Action completed successfully!',
    windAlarmAlertTitle: 'Blind controls auto-disabled',
    windAlarmAlertSubText: 'Due to high wind speeds:',
    windAlarmAlertSubTextInfo: '{{direction}}',
    windAlarmSafetyThreshold: 'Safety treshold: 30 m/s',
  },
  directions: {
    north: {
      abr: 'N',
      long: 'north',
    },
    south: {
      abr: 'S',
      long: 'south',
    },
    east: {
      abr: 'E',
      long: 'east',
    },
    west: {
      abr: 'W',
      long: 'west',
    },
    northeast: {
      abr: 'NE',
      long: 'north-east',
    },
    northwest: {
      abr: 'NW',
      long: 'north-west',
    },
    southeast: {
      abr: 'SE',
      long: 'south-east',
    },
    southwest: {
      abr: 'SW',
      long: 'south-west',
    },
  },
  weekdays: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
  },
  perfAudit: {
    pageTitle: 'Performance Audit',
    exceedance: 'Exceedances',
    manualOverride: 'Manual Override',
    outsideThreshold: 'Time out of threshold',
    comfortThresholdInfo: 'within comfortable threshold',
    comfortThresholdAdditionalInfo: 'during',
    runAudit: 'Run Audit',
    underPerf: 'Below 60%',
    avgPerf: '60% - 90%',
    overPerf: 'Over 90%',
    timerangeSelectors: {
      pastMonth: 'Past 30 Days',
      pastWeek: 'Past 7 Days',
      yesterday: 'Yesterday',
    },
    hourSelector: {
      workingHours: 'Office Hours',
      dayHours: '24 Hours',
    },
    exceedanceIn: 'exceedance in',
    performance: 'Performance',
    roomName: 'Room Name',
    roomsAnalysed: 'Rooms analyzed',
    roomsBelow60: 'Performance < 60%',
    perfScore: 'Performance score',
  },
  controls: {
    pageTitle: 'Controls',
    blinds: 'Blinds',
    lighting: 'Lights',
    climate: 'Climate',
    setTemperature: 'Set Temperature',
    roomTemperature: 'Room Temperature',
    wrongNetwork: {
      header: 'Error loading room controls',
      step1: 'Connect to your local Wi-Fi access point',
      step2: 'Scan the room control QR code with your camera',
      step3:
        'You will automatically be connected to the Next Sense room controls app!',
    },
    loggedOut: {
      header: 'You have been logged out',
      explanation:
        'Your session has expired. Please scan the room QR code to log back into your room controls.',
      action: 'Click to scan QR code',
      close: 'Close camera',
    },
    faq: 'FAQ',
    roomControlHelp: 'Room Control Help',
    sessionTimeLeft: 'Session time left',
    space: 'Space',
    facade: 'Facade',
  },
  faq: {
    new: 'New',
    blinds: {
      title: 'Blinds',
      during_work: {
        blockTitle: 'During work hours',
        blockDescription:
          'The system reduces glare while keeping your workspace comfortable and letting you enjoy a clear view outside.',
        fully_open: {
          question: 'Why are the blinds <strong>fully open?</strong>',
          answer:
            "<p>When sunlight levels are <strong>below 5,000 lux</strong>, there's no risk of glare on screens, so the blinds stay open to let in as much natural daylight as possible.</p>",
        },
        partially_closed: {
          question: 'Why are the blinds <strong>partially closed?</strong>',
          answer:
            "<p>The system <strong>automatically adjusts</strong> the blinds throughout the day to keep your workspace comfortable and glare-free.</p><p>When sunlight levels are <strong>between 5,000 and 20,000 lux</strong>, the blinds use smart shadow tracking to follow the sun's position.</p><p>This means they may move up or down to <strong>prevent direct glare</strong> while still letting in natural light.</p><p>As the sun shifts, the blinds adjust in <strong>real time</strong> to maintain the right balance of shade and brightness.</p>",
        },
        eye_level: {
          question: 'Why are the blinds <strong>closed to eye level?</strong>',
          answer:
            '<p>When the outdoor sunlight <strong>exceeds 20,000 lux</strong> (very bright conditions), the blinds automatically lower to eye level.</p><p>This helps <strong>reduce glare and heat</strong> while still allowing you to enjoy outside views.</p><p>The system is designed to provide <strong>maximum daylight and openness</strong> without compromising comfort, adjusting the blinds just enough to prevent uncomfortable brightness indoors.</p>',
        },
      },
      non_work: {
        blockTitle: 'During non-work hours',
        blockDescription:
          'The blinds move into energy-saving mode to help control heating and cooling in the building.',
        open: {
          question: 'Why are the blinds <strong>open?</strong>',
          answer:
            "<p>The system uses natural light and outdoor temperatures to help regulate the room efficiently.</p><p><strong>If it's sunny</strong> and the room is cooler than your set temperature, the blinds open to let in sunlight and naturally warm the space.</p><p><strong>On cloudy or overcast days,</strong> if it's cooler outside than inside and the room is too warm, the blinds open to help release excess heat.</p><p><strong>Alternatively, if it's warmer outside than inside</strong> and the room is too cool, the blinds will also open to allow some of that outdoor warmth in.</p><p>In each case, the goal is to maintain comfort while reducing the need for active heating or cooling.</p>",
        },
        closed: {
          question: 'Why are the blinds <strong>closed?</strong>',
          answer:
            "<p>The system closes the blinds to help manage heat and maintain a comfortable temperature.</p><p><strong>If it's sunny</strong> and the room is already warmer than your set temperature, the blinds close to block additional heat from entering.</p><p><strong>On cloudy or overcast days,</strong> if it's cooler outside than inside and the room is too cool, the blinds stay closed to keep the warmth in.</p><p><strong>Similarly, if it's warmer outside than inside</strong> and the room is too warm, the blinds close to prevent more heat from entering.</p><p>This way, the system keeps the indoor temperature as stable and comfortable as possible, while minimizing energy use.</p>",
        },
      },
      manual_override: {
        blockTitle: 'MANUAL OVERRIDE',
        blockDescription:
          'You have flexible control over your blinds, with the ability to switch between manual and automatic settings as needed.',
        control: {
          question:
            'How do I switch <strong>between manual and automatic control?</strong>',
          answer:
            '<p>You can easily switch between manual and auto control right in the app! Just open the Next Sense Control App and <strong>tap the toggle switch to select the mode</strong> that works best for you</p>',
        },
        adjustment: {
          question:
            'What happens <strong>after I make a manual adjustment to the blinds?</strong>',
          answer:
            '<p><strong>When you make a manual change, it will stay in effect for 12 hours.</strong> After that, the system automatically goes back to its usual automatic settings.</p>',
        },
        auto_mode: {
          question:
            'When does the system <strong>return to automatic control?</strong>',
          answer:
            '<p><strong>The system will switch back to auto mode in a few cases:</strong> after 12 hours, outside of business hours, or if you manually switch it back in the app.</p>',
        },
      },
    },
    temperature: {
      title: 'Temperature',
      how_it_works: {
        blockTitle: 'How it works',
        blockDescription:
          'You can adjust the temperature in your room within limits set by your building.',
        control: {
          question: 'How does <strong>temperature control work</strong> in my room?',
          answer:
            '<p>Your room has a default <strong>set temperature</strong> established by your building that you can adjust to your own comfort levels. Use the <strong>−</strong> and <strong>+</strong> buttons in the Climate panel to change it.</p><p>Below the set temperature, you can see the current <strong>room temperature</strong>.</p><p>You can only change the temperature while the room is in use.</p>',
        },
        limits: {
          question: 'How much <strong>can I change</strong> the temperature?',
          answer:
            '<p>Your building sets the highest and lowest temperatures you can choose. Contact your facility manager for more information.</p>',
        },
        response_time: {
          question: 'How long until I <strong>feel the difference</strong>?',
          answer:
            "<p>The set temperature changes straight away, but the room takes time to follow. You'll usually notice a difference after about <strong>30 minutes</strong>. Some systems react faster than others.</p><p><strong>Give it time before you change it again.</strong> Changing it repeatedly, or jumping to the highest or lowest value, won't make the room warm up or cool down faster.</p>",
        },
        duration: {
          question: 'How long <strong>does my setting stay</strong>?',
          answer:
            "<p>Your setting stays active <strong>until the end of the day</strong>, or until the room has been <strong>empty for a set time</strong> (at least 30 minutes). After that, the room goes back to the building's default temperature to save energy.</p>",
        },
        outside_hours: {
          question: 'What happens <strong>outside working hours</strong>?',
          answer:
            '<p>Outside working hours, the building switches to an energy-saving temperature. If you arrive early or stay late, the room may feel cooler or warmer at first.</p>',
        },
      },
      not_working: {
        blockTitle: 'Something not working?',
        blockDescription:
          'Try these steps first. If the problem continues, report it to your facility manager and mention the issue number.',
        app_not_loading: {
          question: "The <strong>app doesn't load</strong> after scanning the QR code",
          answer:
            "<p>Try these steps:</p><ol><li>Wait a couple of minutes and scan the QR code again.</li><li>Open the link in a different browser.</li><li>Switch from Wi-Fi to mobile data, or the other way round.</li></ol><p>If the app still doesn't load, report <strong>issue 1</strong> with the room name or unit number.</p><note>The QR code in one room can work while another doesn't, so always say which room is affected.</note>",
        },
        value_missing: {
          question: "A <strong>temperature value isn't showing</strong>",
          answer:
            "<p>Check what is missing:</p><ul><li><code>2.1.1</code> Room temperature</li><li><code>2.1.2</code> Set temperature</li><li><code>2.1.3</code> Both</li></ul><p>Then try these steps:</p><ol><li>Wait a couple of minutes and scan the QR code again.</li><li>Open the link in a different browser.</li><li>Switch from Wi-Fi to mobile data, or the other way round.</li></ol><p>If it still doesn't show, report the matching issue number.</p>",
        },
        wrong_reading: {
          question: 'The <strong>room temperature looks wrong</strong>',
          answer:
            '<p>The room temperature comes from a sensor in your room. Readings can vary depending on where the sensor is located.</p><p>Report <strong>issue 2.2</strong> if the value is clearly wrong, for example:</p><ul><li>The app shows 15°C while the room feels like a normal 21°C</li><li>The app shows an unrealistic value, such as −10°C or 40°C</li></ul><p>When you report it, include the value the app shows and what you expected.</p>',
        },
        setting_reverted: {
          question: 'My setting <strong>went back</strong> after I changed it',
          answer:
            "<p>You can only change the temperature while the room is in use. If the room isn't occupied, no changes are applied.</p><p>If you're in the room and the value jumps back right after you change it:</p><ol><li>Wait 30 seconds and set it again.</li><li>To check whether it worked, refresh the page 30 seconds after setting the new value. If the old value comes back, your change didn't reach the system.</li></ol><p>If this happens, report <strong>issue 2.3</strong>.</p><note>Did your setting go back later in the day? That's usually expected. See \"How long does my setting stay?\"</note>",
        },
      },
      still_uncomfortable: {
        blockTitle: 'Still too warm or too cold?',
        blockDescription:
          "If the app works but you're still not comfortable, your facility manager can take a closer look.",
        uncomfortable: {
          question:
            "I've adjusted the temperature but I'm <strong>still uncomfortable</strong>",
          answer:
            "<p>Temperature changes can take 30 minutes or longer to take effect.</p><p>If the app worked without problems, and after waiting you're still too warm or too cold, report the issue to your facility manager to further check the heating and cooling in your room.</p>",
        },
      },
      reporting: {
        blockTitle: 'Reporting an issue',
        blockDescription:
          'Your facility manager collects all reports and passes them to the Next Sense support team.',
        report: {
          question: 'How do I <strong>report a problem</strong>?',
          answer:
            '<p>Contact your facility manager and include:</p><ul><li><strong>Room name or unit number</strong>: shown at the top right of the app</li><li><strong>Date and time</strong> the problem happened</li><li><strong>Issue number</strong> from this FAQ, for example 2.2</li><li><strong>What you saw and what you expected</strong>, for example the value on the screen</li></ul><note>Example: "Unit 2.10, 13 October, 10:00, issue 2.2. Room temperature shows 0°C, expected around 21°C."</note>',
        },
      },
    },
  },
  otpAuth: {
    sendLoginCode: 'Send Login Code',
  },
};

export default en;
